/**
 * Valida o formulário de novo/editar membro.
 * Retorna objeto com erros por campo.
 */
export const validarFormulario = (values) => {
    const erros = {};

    if (!values.usr_nome) {
        erros.usr_nome = "Nome é obrigatório.";
    }

    if (!values.email) {
        erros.email = "E-mail é obrigatório.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        erros.email = "Informe um e-mail válido.";
    }

    return erros;
};

